import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { BsArrowRepeat, BsEraser } from "react-icons/bs";
import LoadingStuck from "../../../reuse/LoadingStuck";
import Api, { BaseUrl } from "../../../../api/Api";



const getManyLogs = async(data) => {
    try {
        const response = await Api({
            method:"post",
            url:`/logs/`,
            headers:{},
            data:data
        })
        return response
    } catch (error) {
        throw error;
    }
}

const LogsTableLines = ({data, getNextLogs}) => {
    if(data.length==0){
        return(<tbody><tr><td colSpan={5}>Данных нет</td></tr></tbody>)
    }

    // return(
    //     <>
    //         <p>{JSON.stringify(data)}</p>
    //     </>
    // )
    return(
    <tbody>
        {/* {JSON.stringify(data)} */}
        {data.map((elem)=>(
            // <p>{JSON.stringify(elem)}</p>
            <tr>
                <td>{new Date(elem.dt).toLocaleString()}</td>
                <td>{JSON.stringify(elem.who_username)}</td>
                <td>{JSON.stringify(elem.action)}</td>
                <td>{JSON.stringify(elem.target)}</td>
                <td>
                    <Form.Control as="textarea" value={JSON.stringify(elem.details)} readOnly></Form.Control>
                </td>
            </tr>
        ))}
        <tr>
            <td colSpan={5}>
                <button 
                variant="light"
                onClick={()=>getNextLogs()} 
                className="free-btn border">
                    Получить следующие логи
                    </button>
                </td>
        </tr>
    </tbody>
    )
}

const ModalFilterDate = ({label, widthValue, filterSetUpFirst,filterSetUpSecond}) => {
    const [showFilter,setShowFilter]=useState(false);
    const [dateStartValue,setDateStartValue]=useState(null);
    const [dateEndValue,setDateEndValue]=useState(null);
    const handleSet = () => {
        filterSetUpFirst(dateStartValue);
        filterSetUpSecond(dateEndValue);
        setShowFilter(false);
    }
    return(
        <div>
            <span onClick={()=>setShowFilter(!showFilter)} className="filterLabel">{label}</span>
            {showFilter && 
            <div className="filterBlock" style={{width:widthValue}}>
                <Form.Text>От</Form.Text>
                <Form.Control 
                id={label}
                type="datetime-local"
                className="mb-1"
                onChange={(e)=>setDateStartValue(e.target.value)}
                value={dateStartValue}
                size="sm"/>

                <Form.Text>До</Form.Text>
                <Form.Control 
                id={label}
                type="datetime-local"
                className="mb-1"
                onChange={(e)=>setDateEndValue(e.target.value)}
                value={dateEndValue}
                size="sm"/>

                <Button 
                onClick={()=>handleSet()}
                className="custom-btn free-btn" size="sm">Применить</Button>
            </div>}
        </div>
    )
}

const ModalFilterSelectOne = ({label, idName, filterSetUp, widthValue, options}) => {
    const [showFilter,setShowFilter]=useState(false);
    const [selectValue,setSelectValue]=useState(null);
    const handleSet = () => {
        if(selectValue==null){
            filterSetUp(null);
        }else{
            filterSetUp([selectValue]);
        }
        setShowFilter(false);
    }
    return(
        <div>
            <span onClick={()=>setShowFilter(!showFilter)} className="filterLabel">{label}</span>
            {showFilter && 
            <div className="filterBlock" style={{width:widthValue}}>
                <Form.Select 
                id={idName}
                onChange={(e)=>{
                    const val = e.target.value;
                    setSelectValue(val === "" ? null : val);
                }}
                size="sm">
                    <option value="">...</option>
                    {options.map((item)=>(<option value={item}>{item}</option>))}
                </Form.Select>
                <Button 
                onClick={()=>handleSet()}
                className="custom-btn free-btn mt-1" 
                size="sm">Применить</Button>
            </div>}
        </div>
    )
}

const ModalFiltersMultipul = ({label,widthValue, filterSetUp, options}) => {
    const [showFilter,setShowFilter]=useState(false);

    const [userData,setUserData]=useState(null);
    const [AuditData,setAuditData]=useState(null);
    const [test,setTest]=useState(null);
    const [facility,setFacility]=useState(null);

    const handleSet = () => {
        let data = []
        if (userData!==null){
            data.push(
                {ref_id: userData,target_type:"User"}
            )
        }
        if (AuditData!==null){
            data.push(
                {ref_id: AuditData,target_type:"Audit"}
            )
        }
        if (test!==null){
            data.push(
                {ref_id: test,target_type:"Test"}
            )
        }
        if (facility!==null){
            data.push(
                {ref_id: facility,target_type:"Facility"}
            )
        }

        filterSetUp(data);
        setShowFilter(false);
    }
    
    return(
        <div>
            <span onClick={()=>setShowFilter(!showFilter)} className="filterLabel">{label}</span>
            {showFilter && 
            <div className="filterBlock" style={{width:widthValue}}>
                <Form.Text>User</Form.Text>
                <Form.Select 
                id="User"
                className="mb-1"
                onChange={(e)=>setUserData(e.target.value)}
                value={userData}
                size="sm">
                    <option value={null}>...</option>
                    {options.User.map((item)=>(<option value={item}>{item}</option>))}
                </Form.Select>

                <Form.Text>Audit</Form.Text>
                <Form.Select 
                id="Audit"
                className="mb-1"
                onChange={(e)=>setAuditData(e.target.value)}
                value={AuditData}
                size="sm">
                    <option value={null}>...</option>
                    {options.Audit.map((item)=>(<option value={item}>{item}</option>))}
                </Form.Select>

                <Form.Text>Test</Form.Text>
                <Form.Select 
                id="Test"
                className="mb-1"
                onChange={(e)=>setTest(e.target.value)}
                value={test}
                size="sm">
                    <option value={null}>...</option>
                    {options.Test.map((item)=>(<option value={item}>{item}</option>))}
                </Form.Select>

                <Form.Text>Facility</Form.Text>
                <Form.Select 
                id="Facility"
                className="mb-1"
                onChange={(e)=>setFacility(e.target.value)}
                value={facility}
                size="sm">
                    <option value={null}>...</option>
                    {options.Facility.map((item)=>(<option value={item}>{item}</option>))}
                </Form.Select>
                
                <Button 
                onClick={()=>handleSet()}
                className="custom-btn free-btn mt-1" 
                size="sm">Применить</Button>
            </div>}
        </div>
    )
}

const LogsTableInterface = ({filterData}) => {
    const [dataLogs,setLogs]=useState([]);
    const [nextCursor,setNextCursor]=useState(null);
    const [exceedLimit,setExceedLimit]=useState(null);

    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [errorInfo,setErrorInfo]=useState(null);

    const getLogs = async() => {
        setLoading(true)
        try {
            const response = await getManyLogs(filterData)
            // console.log(response.data)
            setLogs(response.data.logs);
            setNextCursor(response.data.next_cursor);
            setExceedLimit(response.data.exceed_limit)
            // console.log(response.data.exceed_limit);
        } catch (error) {
            // alert(error)
            setError(true);
            // setErrorInfo("Ошибка при подгрузке даннных о логах")
            setErrorInfo(error);
        }
        setLoading(false)
    }

    const getNextLogs = async()=> {
        try {
            const filters=filterData;
            filters["cursor"]=nextCursor;
            // console.log(filters)
            const response = await getManyLogs(filters)
            // console.log(response.data.logs);
            setLogs(prev=>[...prev, ...response.data.logs])
            setNextCursor(response.data.next_cursor)
            setExceedLimit(response.data.exceed_limit)
            console.log(response.data.exceed_limit);
        } catch (error) {
            alert(error)
        }
    }

    const getUpdateLogs = async()=> {
        try {
            const response = await getManyLogs(filterData)
            // console.log(response.data.logs);
            setLogs(prev=>[...response.data.logs, ...prev])
            console.log("апдейт получен")
        } catch (error) {
            alert(error)
        }
    }

    useEffect(()=>{
        getLogs();
    },[filterData])

    // useEffect(()=>{
    //     setInterval(getUpdateLogs, 10 * 1000);
    // },[])

    if(loading){return(<tbody><tr><td colSpan={5}>Загрузка...</td></tr></tbody>)}
    if(error){return(<tbody><tr><td colSpan={5}>{errorInfo}</td></tr></tbody>)}
    return(
        <>
        <LogsTableLines data={dataLogs} getNextLogs={getNextLogs}/>
        </>
    )
}

const TableLogsDataInterface = ({filters}) => {
    const limit=100;
    const [filterData,setFilterData]=useState({limit:limit})

    const [startDate,setStartDate]=useState(null);
    const [endDate,setEndDate]=useState(null);
    const [who,setWho]=useState(null);
    const [actions,setActions]=useState(null);
    const [target,setTarget]=useState(null);

    const checkFilters = () => {
        setFilterData({
            limit:limit,
            start_dt:startDate,
            end_dt:endDate,
            who_usernames:who,
            actions:actions,
            targets:target,
        })
    }

    useEffect(()=>{
        checkFilters();
    },[startDate,endDate,who,actions,target])

    const clearFilters = () => {
        setFilterData({limit:limit})
    }

    const renderTable = () => {
        return(<LogsTableInterface filterData={filterData}/>)
        // return(<tbody><tr><td colSpan={5}><p>{JSON.stringify(filterData)}</p></td></tr></tbody>)
    }

    return(<>
        {/* <p>{JSON.stringify(filters)}</p> */}
        <div>
            <div style={{display:"flex",flexDirection:"row-reverse", flexWrap:"wrap"}}>
                <div>
                    {/* <Button 
                    variant="light" 
                    className="border m-1"
                    onClick={()=>checkFilters()}
                    >Применить</Button> */}
                    <Button 
                    onClick={()=>clearFilters()}
                    variant="light" 
                    className="border m-1">Очистить</Button>
                </div>
            </div>
            <Table className="border" striped="columns" size="sm" responsive>
                <colgroup>
                    <col className="col-start-dt" />
                    <col className="col-Who" />
                    <col className="col-Action" />
                    <col className="col-Target" />
                    <col className="col-Details" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <ModalFilterDate 
                            label={"start_dt"} 
                            widthValue={"150px"} 
                            filterSetUpFirst={setStartDate}
                            filterSetUpSecond={setEndDate}/>
                        </th>
                        <th>
                            <ModalFilterSelectOne 
                            label="Who"
                            idName="who_usernames"
                            options={filters.who_usernames}
                            filterSetUp={setWho}
                            widthValue={"250px"}/>
                        </th>
                        <th>
                            <ModalFilterSelectOne 
                            label="Action"
                            idName="actions"
                            filterSetUp={setActions}
                            options={filters.actions}
                            widthValue={"180px"}/>
                        </th>
                        <th>
                            <ModalFiltersMultipul 
                            label="Target"
                            options={filters.targets}
                            filterSetUp={setTarget}
                            widthValue={"170px"}/>
                        </th>
                        <th>Details</th>
                    </tr>
                </thead>
                {renderTable()}
            </Table>
        </div>
    </>)
}

const FetchData = () => {  
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [errorInfo,setErrorInfo]=useState(null);
    const [block,setBlock]=useState(false);

    const [dataFilters,setDataFilters]=useState(null);

    const getFilters = async() =>{
        try {
            const result = await Api({
                method:"get",
                url:`/logs/get_filters`,
                headers:{}
            })
            return (result.data);   
        } catch (error) {
            throw error;
        }
    }

    const getAllData = async() => {
        try {
            const result_filters=await getFilters();    
            setDataFilters(result_filters);
            setBlock(true);
        } catch (error) {
            // setErrorInfo("Ошибка при получении фильтров");
            setErrorInfo(error);
            setError(true);
        }
    }
    
    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getAllData();
            setLoading(false);
        };
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text sepatate_text">{errorInfo}</p>)}
    if(block){return(<TableLogsDataInterface filters={dataFilters}/>)}
}

const AdminLogsBlock = () => {
    return(
        <>
        <FetchData/>
        </>
    )
}
export default AdminLogsBlock;